import styled from 'styled-components';
import { mediaSm } from 'theme/theme-helper-selectors';

export const Gradient = styled.div`
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    width: 72%;
    height: 72%;
    border-radius: 50%;
    background: linear-gradient(
        137.32deg,
        rgba(119, 51, 255, 1) 24.807%,
        rgba(53, 202, 238, 1) 96.831%
    );
    filter: blur(175px);
    z-index: -1;
`;

export const SliderContainer = styled.div`
    display: none;

    @media (${mediaSm}) {
        display: block;
    }
`;

export const NewsDesktopContainer = styled.div`
    display: block;

    @media (${mediaSm}) {
        display: none;
    }
`;
